import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalOptions, ModalRef, ModalService } from '@vinnova/ui';
import { filter } from 'rxjs';
import { environment } from '../../environment';
import { AuthCookieService } from '../../services/auth-cookie.service';
import { SignalRService } from '../../services/signalr.service';

@UntilDestroy()
@Component({
  selector: 'lib-already-logged-in',
  templateUrl: './already-logged-in.component.html',
  standalone: false,
})
export class AlreadyLoggedInComponent implements OnInit {
  config: ModalOptions = {
    backdrop: 'static',
  };

  @ViewChild('adminLoginRequest')
  alreadyLoggedInTemplate: TemplateRef<unknown> | undefined;
  alreadyLoggedInModalRef: ModalRef | undefined;

  private modalService = inject(ModalService);
  private env = inject(environment);
  private signalRService = inject(SignalRService);
  private translocoService = inject(TranslocoService);
  private authCookieService = inject(AuthCookieService);

  ngOnInit() {
    this.signalRService.alreadyLoggedIn$
      .pipe(
        filter(() => !this.isEffektaSharedView()),
        untilDestroyed(this),
      )
      .subscribe((msg) => {
        if (msg.operation === 'open' && this.alreadyLoggedInTemplate) {
          this.alreadyLoggedInModalRef = this.modalService.show(
            this.alreadyLoggedInTemplate,
            this.config,
          );
        } else if (msg.operation === 'close' && this.alreadyLoggedInModalRef) {
          this.alreadyLoggedInModalRef.hide();
        } else if (
          msg.operation === 'openSameBrowser' &&
          !location.href.includes('testform') &&
          !location.href.includes('previewform')
        ) {
          const text =
            this.translocoService.getActiveLang() === 'sv'
              ? 'Du har redan öppnat Vinnovas e-tjänster i en annan flik'
              : "You have already opened Vinnova's e-services in another tab";
          const mainElement = document.querySelector('main');
          if (mainElement) {
            mainElement.innerHTML = `<div class="container mt-5"><p>${text}</p></div>`;
          }
        }
      });
  }

  acceptTakeover() {
    this.alreadyLoggedInModalRef?.hide();
    this.signalRService.invoke(
      'registerTakeover',
      this.authCookieService.getSessionId(),
    );
  }

  rejectTakeover() {
    this.alreadyLoggedInModalRef?.hide();
    globalThis.location.replace(`${this.env.etjansterCommonUrl}/public/logout`);
  }

  isEffektaSharedView() {
    const regex =
      /^https?:\/\/[^/]+\/projekt\/(budget|isEffektaSharedView|inrapporterade-kostnader)\/\d{4}-\d{5}(\/(write|read))?\/effekta(\/[^/]+)?$/;
    return regex.test(location.href);
  }
}
